import React from 'react';
import moment from 'moment';

const SectionDate = ({ startedAt, expiredAt, setStartedAt, setExpiredAt }) => {
  React.useEffect(() => {
    if (window.innerWidth >= 768) {
      $('.datetimepicker').each(function() {
        $(this).datetimepicker({
          format: 'Y/m/d H:i',
          lang: 'ja',
          scrollInput: true,
          timepicker: true,
          step: 5
        });
      });
    }
  }, []);

  let datetimeFormType;
  let datetimeFormat;
  if (window.innerWidth >= 768) {
    datetimeFormType = 'text';
    datetimeFormat = 'YYYY/MM/DD HH:mm';
    $('.datetimepicker').each(function() {
      $(this).datetimepicker({
        format: 'Y/m/d H:i',
        lang: 'ja',
        scrollInput: true,
        timepicker: true,
        step: 5
      });
    });
  } else {
    datetimeFormType = 'datetime-local';
    datetimeFormat = 'YYYY-MM-DDTHH:mm';
  }

  return (
    <section id="event_date">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-5 d-inline-block">
          プロジェクトの申し込み日時
          <span className="text-fz-14px text-fw-bold text-orange mb-2 mt-1 ml-2 d-inline-block">
            必須
          </span>
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className={`container col-md-8 col-lg-6`}>
          <label
            htmlFor="event-start-datetime-input-form"
            className="row justify-content-between p-3_5 border-bottom"
          >
            <p className="p-0 mb-0">開始日</p>
            <input
              type={datetimeFormType}
              className="datetimepicker form-style-reset p-0 textarea--eventreport text-right bg-gray"
              id="event-start-datetime-input-form"
              value={startedAt ? moment(startedAt).format(datetimeFormat) : ''}
              onChange={e => {
                setStartedAt(e.target.value);
              }}
              placeholder="必須"
              autoComplete="off"
            />
          </label>
          <label
            htmlFor="event-end-datetime-input-form"
            className="row justify-content-between p-3_5"
          >
            <p className="pr-2 mb-0">終了日</p>
            <input
              type={datetimeFormType}
              className="datetimepicker form-style-reset p-0 textarea--eventreport text-right bg-gray"
              id="event-end-datetime-input-form"
              value={expiredAt ? moment(expiredAt).format(datetimeFormat) : ''}
              onChange={e => {
                setExpiredAt(e.target.value);
              }}
              placeholder="必須"
              autoComplete="off"
            />
          </label>
        </div>
      </div>
    </section>
  );
};

export default SectionDate;
